var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", { staticClass: "pb-1 bb-2" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("p", { staticClass: "fs-3 mt-3 gray-60" }, [
        _vm._v(_vm._s(_vm.subtitle))
      ]),
      _vm._v(" "),
      _vm.banks.length > 0
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.banks, "show-header": false, border: "" }
            },
            [
              _c("el-table-column", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("p", { staticClass: "info-label" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Banque")))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "info-value" }, [
                            _vm._v(_vm._s(scope.row.bankName))
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1155439128
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("p", { staticClass: "info-label" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Nom du compte")))
                          ]),
                          _vm._v(" "),
                          scope.row.accountName
                            ? _c("p", { staticClass: "info-value" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(scope.row.accountName) +
                                    "\n                "
                                )
                              ])
                            : _c("p", { staticClass: "info-value orange" }, [
                                _vm._v(_vm._s(_vm.$l10n.__("Non renseigné")))
                              ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4078290129
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.status != null
                            ? _c("bank-status", {
                                attrs: { status: scope.row.status }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2418983962
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "aright" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__(
                                    "preferences.BankTable.view_more"
                                  ),
                                  type: "secondary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("open", scope.row.id)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  433240292
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }